import { showMessageModal } from '~/clientUtils/showMessageModal';
import { CandidateKey } from '~/definitions/candidates';
import React from 'react';
import { CANDIDATE_FIELD_CONFIG, CANDIDATE_FIELD_CONFIG_LEFT } from '~/consts/candidates';

export const showMessageModalWithFieldKeys = (keys: CandidateKey[]) => {
    const pClassName = 'm-0';

    const message = (
        <div className={'items-center flex flex-col'}>
            <p className={pClassName}>Følgende felfer er feil</p>
            {keys.map((k) => {
                const foundName =
                    [...CANDIDATE_FIELD_CONFIG, ...CANDIDATE_FIELD_CONFIG_LEFT].find((c) => c.key === k)?.name || '';
                return (
                    <p key={k} className={pClassName}>
                        {foundName}
                    </p>
                );
            })}
            <p className={pClassName}>Klikk på teksten for å fjerne denne meldingen.</p>
        </div>
    );

    showMessageModal('error', message);
};
